<template>
  <div class="pac-wrapper" ref="pacWrapper">
    <!-- Header -->
    <div class="pac-header">
      <div class="contract-info">
        <div class="contract-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"></path>
            <path d="M3 5v14a2 2 0 0 0 2 2h16v-5"></path>
            <path d="M18 12a2 2 0 0 0 0 4h4v-4Z"></path>
          </svg>
        </div>
        <div class="contract-details">
          <span class="contract-label">Pagos Automáticos</span>
          <span class="contract-number">PAC - Pago Automático en Cuenta</span>
        </div>
      </div>
      <div class="pac-status">
        <div class="status-badge" :class="pac ? 'active' : 'inactive'">
          <span class="status-dot"></span>
          <span class="status-text">{{
            pac ? "Activo" : "Sin configurar"
          }}</span>
        </div>
      </div>
    </div>

    <!-- No PAC State -->
    <div class="pac-empty-state" v-if="!pac">
      <div class="empty-card">
        <div class="empty-illustration">
          <div class="illustration-icons">
            <div class="icon-circle bank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect width="20" height="14" x="2" y="5" rx="2" />
                <line x1="2" x2="22" y1="10" y2="10" />
              </svg>
            </div>
            <div class="arrow-connector">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M5 12h14" />
                <path d="m12 5 7 7-7 7" />
              </svg>
            </div>
            <div class="icon-circle portal">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <rect width="18" height="18" x="3" y="3" rx="2" />
                <path d="M3 9h18" />
                <path d="M9 21V9" />
              </svg>
            </div>
          </div>
        </div>
        <div class="empty-content">
          <h3 class="empty-title">Conecta tu cuenta bancaria</h3>
          <p class="empty-description">
            Configura el PAC (Pago Automático en Cuenta Corriente) para
            automatizar tus pagos. Tu banco realizará los cobros automáticamente
            según las fechas de tu plan de pagos.
          </p>
          <ul class="benefits-list">
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Sin preocuparte por fechas de vencimiento
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Proceso 100% seguro con tu banco
            </li>
            <li>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Puedes cancelarlo cuando quieras
            </li>
          </ul>
        </div>
        <button
          class="add-pac-btn"
          @click="addFintoc()"
          :disabled="contract_id == null"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"></path>
            <path d="M3 5v14a2 2 0 0 0 2 2h16v-5"></path>
            <path d="M18 12a2 2 0 0 0 0 4h4v-4Z"></path>
          </svg>
          Agregar PAC
        </button>
      </div>
    </div>

    <!-- PAC Active State -->
    <div class="pac-active-state" v-else>
      <!-- Info Alert -->
      <div class="info-alert">
        <div class="alert-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 16v-4" />
            <path d="M12 8h.01" />
          </svg>
        </div>
        <p class="alert-text">
          Esta cuenta PAC del banco
          <strong>{{ getBank(pac.institution_id).name }}</strong> realizará
          automáticamente los pagos de tu plan. Los pagos pueden tardar entre 48
          a 72 horas en hacerse efectivos.
        </p>
      </div>

      <!-- Bank Card -->
      <div class="bank-card">
        <div class="bank-logo-section">
          <img
            :src="getBank(pac.institution_id).img"
            :alt="getBank(pac.institution_id).name"
            class="bank-logo"
            v-if="getBank(pac.institution_id).img"
          />
          <div class="bank-logo-placeholder" v-else>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect width="20" height="14" x="2" y="5" rx="2" />
              <line x1="2" x2="22" y1="10" y2="10" />
            </svg>
          </div>
          <div class="bank-name-badge">{{ pac.institution_name }}</div>
        </div>
        <div class="bank-info-section">
          <h4 class="section-title">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"></path>
              <path d="M3 5v14a2 2 0 0 0 2 2h16v-5"></path>
              <path d="M18 12a2 2 0 0 0 0 4h4v-4Z"></path>
            </svg>
            Información del PAC
          </h4>
          <div class="info-grid">
            <div class="info-item">
              <span class="info-label">Titular</span>
              <span class="info-value">{{ pac.holder_name }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Banco</span>
              <span class="info-value">{{ pac.institution_name }}</span>
            </div>
            <div class="info-item" v-if="pac.official_name">
              <span class="info-label">Tipo de cuenta</span>
              <span class="info-value">{{ pac.official_name }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Número de cuenta</span>
              <span class="info-value account-number">{{ pac.number }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">ID del PAC</span>
              <span class="info-value">{{ pac.holder_id }}</span>
            </div>
            <div class="info-item">
              <span class="info-label">Fecha de activación</span>
              <span class="info-value">{{ parseDate(pac.created_at) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <WidgetFintoc
      v-if="showWidget"
      @showWidget="showWidgetAction"
      @dataResultWidget="resultSuccessWidget"
      :project_id="this.apartment.project_id"
    ></WidgetFintoc>
  </div>
</template>

<script>
import WidgetFintoc from "./WidgetFintoc.vue";

export default {
  name: "payments",
  emits: ["showWidget", "dataResultWidget"],
  components: {
    WidgetFintoc,
  },
  props: {
    asset_id: null,
    project_id: { default: null },
    response_pac: { default: null },
  },
  data() {
    return {
      customStyles: {
        li: {
          display: "inline-block",
        },
        a: {
          color: "black",
        },
      },
      customLabels: {
        first: "<<",
        last: ">>",
        previous: "<",
        next: ">",
      },
      pageOfItems: [],
      loading: true,
      showWidget: false,
      pac: null,
    };
  },
  computed: {
    contract_id() {
      return this.$store.getters.getContractId == undefined
        ? null
        : this.$store.getters.getContractId;
    },
    apartment() {
      return this.$store.getters.getApartmentById(parseInt(this.asset_id));
    },
  },
  beforeMount() {},
  created() {
    if (this.response_pac != null) this.pac = this.response_pac;
  },
  methods: {
    getBank() {
      if (this.pac.institution_id == "cl_banco_santander")
        return {
          name: "Santander",
          img: require("@/assets/images/banks/Santander.png"),
        };
      else if (this.pac.institution_id == "cl_banco_de_chile")
        return {
          name: "Chile",
          img: require("@/assets/images/banks/Chile.png"),
        };
      else if (this.pac.institution_id == "cl_banco_scotiabank")
        return {
          name: "Scotiabank",
          img: require("@/assets/images/banks/Scotiabank.png"),
        };
      else if (this.pac.institution_id == "cl_banco_itau")
        return { name: "Itau", img: require("@/assets/images/banks/Itau.png") };
      else if (this.pac.institution_id == "cl_banco_bci")
        return { name: "BCI", img: require("@/assets/images/banks/Bci.png") };
      else if (this.pac.institution_id == "cl_banco_falabella")
        return {
          name: "Falabella",
          img: require("@/assets/images/banks/Falabella.png"),
        };
      else if (this.pac.institution_id == "cl_banco_estado")
        return {
          name: "Estado",
          img: require("@/assets/images/banks/Estado.png"),
        };
      else if (this.pac.institution_id == "cl_banco_bice")
        return { name: "Bice", img: require("@/assets/images/banks/Bice.png") };
      else {
        return { name: "", img: "" };
      }
    },
    addFintoc() {
      this.showWidget = true;
    },
    showWidgetAction(stateWidget) {
      this.showWidget = stateWidget;
    },
    resultSuccessWidget(response) {
      this.pac = response.data;
    },
    getPacs() {
      this.axios
        .get(`payments/get_fintoc_pacs?contract_id=${this.contract_id}`)
        .then((result) => {
          this.pac = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    parseDate(date) {
      return this.$moment(date).format("DD-MM-YYYY");
    },
  },
  watch: {
    contract_id: function (new_val) {
      if (new_val) this.getPacs();
    },
  },
};
</script>

<style scoped>
/* ===== Wrapper ===== */
.pac-wrapper {
  padding: 0;
}

/* ===== Header ===== */
.pac-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 20px;
  padding: 20px 24px;
  margin-bottom: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.contract-info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.contract-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-radius: 12px;
  color: var(--color-btn, #3b82f6);
}

.contract-details {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.contract-label {
  font-size: 0.8125rem;
  color: #6b7280;
  font-weight: 500;
}

.contract-number {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
}

.pac-status {
  display: flex;
  align-items: center;
}

.status-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
}

.status-badge.active {
  background: #ecfdf5;
  color: #059669;
}

.status-badge.inactive {
  background: #fef3c7;
  color: #d97706;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.status-badge.active .status-dot {
  background: #10b981;
}

.status-badge.inactive .status-dot {
  background: #f59e0b;
}

/* ===== Empty State ===== */
.pac-empty-state {
  display: flex;
  justify-content: center;
}

.empty-card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
  text-align: center;
}

.empty-illustration {
  margin-bottom: 32px;
}

.illustration-icons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
}

.icon-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 50%;
}

.icon-circle.bank {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #2563eb;
}

.icon-circle.portal {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
}

.arrow-connector {
  color: #9ca3af;
}

.empty-content {
  margin-bottom: 32px;
}

.empty-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
}

.empty-description {
  font-size: 0.9375rem;
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 24px;
}

.benefits-list {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
  display: inline-block;
}

.benefits-list li {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 0.9375rem;
  color: #374151;
  padding: 8px 0;
}

.benefits-list li svg {
  color: #10b981;
  flex-shrink: 0;
}

.add-pac-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 32px;
  background: var(--color-btn, #3b82f6);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.add-pac-btn:hover:not(:disabled) {
  opacity: 0.9;
  transform: translateY(-1px);
}

.add-pac-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ===== Active State ===== */
.pac-active-state {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-alert {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 12px;
  padding: 16px 20px;
}

.alert-icon {
  color: #3b82f6;
  flex-shrink: 0;
  margin-top: 2px;
}

.alert-text {
  font-size: 0.9375rem;
  color: #1e40af;
  line-height: 1.5;
  margin: 0;
}

.alert-text strong {
  font-weight: 600;
}

/* ===== Bank Card ===== */
.bank-card {
  display: flex;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb;
}

.bank-logo-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  min-width: 200px;
  gap: 16px;
}

.bank-logo {
  max-width: 120px;
  max-height: 80px;
  object-fit: contain;
}

.bank-logo-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: #e5e7eb;
  border-radius: 12px;
  color: #9ca3af;
}

.bank-name-badge {
  background: white;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 0.8125rem;
  font-weight: 600;
  color: #374151;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.bank-info-section {
  flex: 1;
  padding: 24px 32px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.125rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.section-title svg {
  color: var(--color-btn, #3b82f6);
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-label {
  font-size: 0.75rem;
  color: #6b7280;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.info-value {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1f2937;
}

.info-value.account-number {
  font-family: "SF Mono", "Menlo", monospace;
  letter-spacing: 0.5px;
}

/* ===== Responsive ===== */
@media (max-width: 768px) {
  .pac-header {
    flex-direction: column;
    align-items: stretch;
    padding: 16px;
    gap: 16px;
  }

  .contract-info {
    justify-content: center;
  }

  .pac-status {
    justify-content: center;
  }

  .bank-card {
    flex-direction: column;
  }

  .bank-logo-section {
    padding: 24px;
    min-width: auto;
  }

  .bank-info-section {
    padding: 20px;
  }

  .info-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .empty-card {
    padding: 24px;
  }

  .icon-circle {
    width: 56px;
    height: 56px;
  }

  .icon-circle svg {
    width: 24px;
    height: 24px;
  }
}

@media (max-width: 576px) {
  .pac-header {
    padding: 12px;
    border-radius: 12px;
  }

  .contract-icon {
    width: 40px;
    height: 40px;
  }

  .contract-icon svg {
    width: 20px;
    height: 20px;
  }

  .contract-number {
    font-size: 1rem;
  }

  .empty-title {
    font-size: 1.25rem;
  }

  .empty-description {
    font-size: 0.875rem;
  }

  .add-pac-btn {
    width: 100%;
    padding: 12px 24px;
  }

  .section-title {
    font-size: 1rem;
  }

  .bank-info-section {
    padding: 16px;
  }
}
</style>
